import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

import { Skeleton } from "@/shared/ui";

const cardSkeletonVariant = tv({
  slots: {
    card: "rounded-2xl bg-secondary-50 p-4",
    skeletonPrimary: "h-5 rounded-full bg-secondary-200",
    skeletonSecondary: "h-5 rounded-full bg-secondary-200",
  },
});

export const CardSkeleton = ({
  className,
}: Pick<ComponentProps<"div">, "className">) => {
  const { card, skeletonPrimary, skeletonSecondary } = cardSkeletonVariant();

  return (
    <div className={card({ className })}>
      <div className="flex gap-7">
        <div className="flex flex-1 flex-col gap-3">
          <Skeleton className={skeletonPrimary()} />
          <Skeleton className={skeletonPrimary()} />
          <Skeleton className={skeletonPrimary()} />
        </div>

        <div className="flex w-1/4 flex-col justify-between">
          <Skeleton className={skeletonSecondary()} />
          <Skeleton
            className={skeletonPrimary({ className: "w-2/3 self-end" })}
          />
        </div>
      </div>
    </div>
  );
};
